import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface TokenAmountEditorProps {
  amount: string;
  isLoading: boolean;
  onAmountChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const TokenAmountEditor = ({
  amount,
  isLoading,
  onAmountChange,
  onSave,
  onCancel,
}: TokenAmountEditorProps) => {
  return (
    <div className="flex items-center gap-4">
      <Input
        type="number"
        value={amount}
        onChange={(e) => onAmountChange(e.target.value)}
        className="max-w-[200px]"
        min="0"
      />
      <Button onClick={onSave} disabled={isLoading}>
        {isLoading ? "Saving..." : "Save"}
      </Button>
      <Button variant="ghost" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  );
};